<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" :model="statusForm" :ref="statusForm"
        style="margin: 0">
        <el-form-item label="项目点：" style="margin-top: 20px;">
          <el-select size="medium" v-model="statusForm.NATURE_CODE_LIST" filterable placeholder="请选择" clearable multiple
            collapse-tags>
            <el-option v-for="item in enterpriseNature" :key="item.value" :label="item.PROJECT_NAME"
              :value="item.PROJECT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-button size="medium" type="primary" @click="filtrate">筛选</el-button>
        <el-button size="medium" type="primary" plain @click="exportList" style="margin-top: 20px">导出</el-button>
        <el-button size="medium" type="primary" plain @click="exportPriceList" style="margin-top: 20px">不同价格汇总导出</el-button>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableList" stripe border style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="价格" prop="PRICE"></el-table-column>
          <el-table-column label="实收数量 " prop="TOTAL_COUNT"></el-table-column>
          <el-table-column label="实收总金额" prop="TOTAL_WORTH"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryTCInvoiceFun, exportTCInvoiceFun, exportTCInvoicePriceFun } from 'api/tcBanlance';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableList: [],
      enterpriseNature: [],
      statusForm: {
        NATURE_CODE_LIST: [],
      },
      isGys: Number(this.$route.params.isgys),
    };
  },
  methods: {
    queryList() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      if (this.statusForm.NATURE_CODE_LIST.length !== 0) {
        params.PROJECT_LIST = this.statusForm.NATURE_CODE_LIST;
      }
      queryTCInvoiceFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableList = result;
          } else {
            this.tableList = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ tetx: error, type: 'error' });
        });
    },
    filtrate() {
      this.queryList();
    },
    queryProject() {
      const params = {
        SERVICE_ID: '10018',
        OTYPE: 4,
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        MONTH: sessionStorage.getItem('MONTH'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        if (res.length !== 0) {
          this.enterpriseNature = res;
        } else {
          this.enterpriseNature = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(sessionStorage.getItem('TC_ID')),
            MONTH: sessionStorage.getItem('MONTH'),
          };
          if (this.statusForm.NATURE_CODE_LIST.length !== 0) {
            params.PROJECT_LIST = this.statusForm.NATURE_CODE_LIST;
          }
          exportTCInvoiceFun(params).then((result) => {
            if (result.length !== 0) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    exportPriceList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(sessionStorage.getItem('TC_ID')),
            MONTH: sessionStorage.getItem('MONTH'),
          };
          exportTCInvoicePriceFun(params).then((result) => {
            if (result.length !== 0) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    this.queryList();
    this.queryProject();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/tcInvoiceDetail.vue